export const TENDER_ACCEPTED_EXTENSIONS =
  ".pdf,.docx,.dotx,.dotm,.xlsx,.xlsm,.xltx,.xltm,.xls,.csv,.txt,.md,.markdown,.html,.htm,.json,.msg"

export const TENDER_ACCEPTED_EXTENSIONS_WITH_ZIP = TENDER_ACCEPTED_EXTENSIONS + ",.zip"

export const TENDER_ACCEPTED_EXTENSIONS_SET = new Set(TENDER_ACCEPTED_EXTENSIONS.split(","))

export const TENDER_ACCEPT_FILTER: Record<string, string[]> = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [".dotx"],
  "application/vnd.ms-word.template.macroEnabled.12": [".dotm"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [".xltx"],
  "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
  "application/vnd.ms-excel": [".xls"],
  "text/csv": [".csv"],
  "text/plain": [".txt", ".md", ".markdown"],
  "text/html": [".html", ".htm"],
  "application/json": [".json"],
  "application/vnd.ms-outlook": [".msg"],
}

export function filterAllowedFiles(files: File[]): { allowed: File[]; rejected: string[] } {
  const allowed: File[] = []
  const rejected: string[] = []
  for (const f of files) {
    const ext = f.name.slice(f.name.lastIndexOf(".")).toLowerCase()
    if (TENDER_ACCEPTED_EXTENSIONS_SET.has(ext)) {
      allowed.push(f)
    } else {
      rejected.push(f.name)
    }
  }
  return { allowed, rejected }
}
